export const formatDateDisplay = (date, format = 'yyyy-MM-dd HH:mm:ss') => {
  let oDate = date;
  if (typeof oDate === 'string') {
    oDate = oDate.replace(/-/g, '/'); // 兼容 safari 的日期格式
    if (oDate.length === 7) { // 2024/05 -> 2024/05/01
      oDate = `${oDate}/01`;
    }
  }
  const d = new Date(oDate);
  const ds = {
    yyyy: d.getFullYear(),
    MM: d.getMonth() + 1,
    dd: d.getDate(),
    HH: d.getHours(),
    mm: d.getMinutes(),
    ss: d.getSeconds(),
  };
  let timeStr = format;
  Object.keys(ds).forEach((k) => {
    if (ds[k] < 10) ds[k] = `0${ds[k]}`;
    else ds[k] = `${ds[k]}`;
    timeStr = timeStr.replace(k, ds[k]);
  });
  return timeStr;
};
export const formatDate = (time, format = 'yyyy-MM-dd HH:mm:ss') => {
  let dateStr = formatDateDisplay(time, format);
  if (typeof dateStr === 'string') {
    dateStr = dateStr.replace(/-/g, '/'); // 兼容 safari 的日期格式
  }
  return new Date(dateStr);
};

export const millisecondToDate = (msd) => {
  let time;
  if (msd != null && msd !== '') {
    time = parseFloat(msd) / 1000;
    if (time > 60 && time < 60 * 60) {
      time = `${parseInt(String(time / 60.0), 10)}分钟${parseInt(String((parseFloat(String(time / 60.0)) -
        parseInt(String(time / 60.0), 10)) * 60), 10)}秒`;
    } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
      time = `${parseInt(String(time / 3600.0), 10)}小时${parseInt(String((parseFloat(String(time / 3600.0)) -
        parseInt(String(time / 3600.0), 10)) * 60), 10)}分钟${
        parseInt(String((parseFloat(String((parseFloat(String(time / 3600.0)) - parseInt(String(time / 3600.0), 10)) * 60)) -
          parseInt(String((parseFloat(String(time / 3600.0)) - parseInt(String(time / 3600.0), 10)) * 60), 10)) * 60), 10)}秒`;
    } else {
      time = `${parseInt(time, 10)}秒`;
    }
  } else {
    time = '';
  }
  return time;
};

/**
 * 今天时间初始化成Date状态
 */
export const initToday = () => {
  const startDate = new Date();
  startDate.setHours(0);
  startDate.setMinutes(0);
  startDate.setSeconds(0);
  const endDate = new Date();
  endDate.setHours(23);
  endDate.setMinutes(59);
  endDate.setSeconds(59);
  return [startDate, endDate];
};

/**
 * 今天时间初始化成参数形式
 */
export const getTodayParams = (startKey, endKey, formatStr) => {
  const times = initToday();
  return startKey && endKey ? { [startKey]: formatDateDisplay(times[0], formatStr), [endKey]: formatDateDisplay(times[1], formatStr) }
    : [formatDateDisplay(times[0], formatStr), formatDateDisplay(times[1], formatStr)];
};

/**
 * 获取一周时间段
 */
export const initWeek = () => {
  const endDate = new Date();
  endDate.setHours(23);
  endDate.setMinutes(59);
  endDate.setSeconds(59);
  const curTime = endDate.getTime() - 7 * 24 * 60 * 59 * 1000;
  const startDate = new Date(curTime);
  startDate.setHours(0);
  startDate.setMinutes(0);
  startDate.setSeconds(0);
  return [startDate, endDate];
};

/**
 * 近 7 天时间初始化成参数形式
 */
export const getWeekParams = (startKey, endKey, formatStr) => {
  const times = initWeek();
  return startKey && endKey ? { [startKey]: formatDateDisplay(times[0], formatStr), [endKey]: formatDateDisplay(times[1], formatStr) }
    : [formatDateDisplay(times[0], formatStr), formatDateDisplay(times[1], formatStr)];
};

/**
 * 获取一月时间段
 */
export const initMonth = () => {
  const curTime = Date.now() - 30 * 24 * 60 * 60 * 1000;
  const startDate = new Date(curTime);
  startDate.setHours(0);
  startDate.setMinutes(0);
  startDate.setSeconds(0);
  const endDate = new Date();
  endDate.setHours(23);
  endDate.setMinutes(59);
  endDate.setSeconds(59);
  return [startDate, endDate];
};

/**
 * 一月时间初始化成参数形式
 */
export const getMonthParams = (startKey, endKey, formatStr) => {
  const times = initMonth();
  return startKey && endKey ? { [startKey]: formatDateDisplay(times[0], formatStr), [endKey]: formatDateDisplay(times[1], formatStr) }
    : [formatDateDisplay(times[0], formatStr), formatDateDisplay(times[1], formatStr)];
};

// chart日期format
export const getChartDate = (datetime) => {
  let time = datetime.split('~')[0];
  if (typeof time === 'string') {
    time = time.replace(/-/g, '/'); // 兼容 safari 的日期格式
  }
  const date = new Date(time);
  const today = new Date();
  const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);
  if (formatDateDisplay(date, 'yyyy/MM/dd') === formatDateDisplay(today, 'yyyy/MM/dd')) {
    return 'Today';
  }
  if (formatDateDisplay(date, 'yyyy/MM/dd') === formatDateDisplay(yesterday, 'yyyy/MM/dd')) {
    return 'Yesterday';
  }
  return `${date.toDateString().split(' ')[1]} ${date.getDate()}`;
};

// 基于当前日期，返回时间范围供时间控件
export const initDaysRangeByToday = (days = 0) => {
  const endDate = new Date();
  endDate.setHours(23, 59, 59, 999);

  const startDate = new Date(endDate);
  startDate.setDate(startDate.getDate() + (days < 0 ? days : 0));
  startDate.setHours(0, 0, 0, 0);

  if (days > 0) {
    endDate.setDate(endDate.getDate() + days);
  }

  return [startDate, endDate];
};
